import actions from '../../../constants/actionTypes';
import { getDate } from '../../../utils/utils';
import { COMMON_CONST } from '../../../constants/constants';
import { EnumPage } from '../../../constants/enum';
import {
  handleChangeFilters,
  handleChangeTableActivePage,
  handleChangeTablePageSize,
} from '../../../redux/genericReducerHandler';

const initialState = {
  filters: {
    fromDate: getDate(-7),
    toDate: getDate(),
  },
  overallReport: {
    totalOrderReport: {
      totalOrder: 0,
      groupByStatus: {
        totalCompletedOrder: {
          value: 0,
        },
        totalReturnSuccessOrder: {
          value: 0,
        },
        totalReturnFailOrder: {
          value: 0,
        },
        totalCancelOrder: {
          value: 0,
        },
      },
      groupByPaymentMethod: [],
    },
    revenueReport: {
      totalRevenue: 0,
      totalShippingFee: {
        value: 0,
        paymentMethods: [],
      },
      totalCod: {
        value: 0,
        paymentMethods: [],
      },
    },
    shipFeeReport: {
      totalShipFee: 0,
      totalShippingFeeOrigin: 0,
      totalReturnFee: 0,
      totalDiscount: 0,
      totalOtherFee: 0,
    },
  },
  table: {
    itemList: [],
    activePage: 1,
    pageSize: COMMON_CONST.PageSize,
  },
};

function reportShipReducer(state = initialState, action) {
  const PAGE = EnumPage.NOW_SHIP_REPORT.id;
  const { response, type } = action;
  switch (type) {
    case actions.CHANGE_TABLE_PAGE_SIZE: {
      return handleChangeTablePageSize(PAGE, state, action);
    }
    case actions.CHANGE_TABLE_ACTIVE_PAGE: {
      return handleChangeTableActivePage(PAGE, state, action);
    }
    case actions.CHANGE_FILTER_GENERIC: {
      return handleChangeFilters(PAGE, state, action, initialState);
    }
    case actions.RECEIVE_DATA_REPORT_NOW_SHIP: {
      const { overallReport, detailReport } = response;
      const { itemList = [] } = detailReport;
      return {
        ...state,
        overallReport,
        table: {
          ...state.table,
          itemList,
          activePage: 1,
        },
      };
    }
    default:
      return state;
  }
}

export default reportShipReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/NowShip/ReportNowShip/reducers.js